import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import CallSplit from '@material-ui/icons/CallSplit';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckBox from '@material-ui/icons/CheckBox';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import SaveReportIcon from '@material-ui/icons/Description';
import DoneAll from '@material-ui/icons/DoneAll';
import DraftsIcon from '@material-ui/icons/Drafts';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ForwardIcon from '@material-ui/icons/Forward';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import GetAppIcon from '@material-ui/icons/GetApp';
import HistoryIcon from '@material-ui/icons/History';
import TourIcon from '@material-ui/icons/LocalLibraryTwoTone';
import MarkunreadIcon from '@material-ui/icons/Markunread';
import MenuIconOpen from '@material-ui/icons/Menu';
import RefreshIcon from '@material-ui/icons/Refresh';
import LockIcon from '@material-ui/icons/Lock';
import UnlockIcon from '@material-ui/icons/LockOpen';
import SaveIcon from '@material-ui/icons/Save';
import ExportExcel from '@material-ui/icons/SaveAlt';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import React from "react";
import { useDispatch } from "react-redux";
import { showTour } from '../../actions';
import MissingItemsDrawer from './custom/missinglists';
import History from './history';
import RulesSnapShot from './rulesSnapshot';
// import DirectionsTwoToneIcon from '@material-ui/icons/DirectionsTwoTone';
// import CameraFrontRoundedIcon from '@material-ui/icons/CameraFrontRounded';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { getColor } from './custom/customcolor';
import { Autorenew, Help, Restore } from '@material-ui/icons';
import InputSharpIcon from '@material-ui/icons/InputSharp';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import Preview from '@material-ui/icons/Visibility';
import { getEnvVariable } from '../../../modules/environmentalList';
import QuickView from './quickview';
import DateRangeIcon from '@material-ui/icons/DateRange';
import HowToRegSharpIcon from '@material-ui/icons/HowToRegSharp';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';
//import Filter from '@material-ui/icons/FilterList';
import CameraFrontRoundedIcon from '@material-ui/icons/CameraFrontRounded';
import DirectionsTwoToneIcon from '@material-ui/icons/DirectionsTwoTone';
import SyncIcon from '@material-ui/icons/Sync';
import PauseIcon from '@material-ui/icons/Pause';
import LaptopIcon from '@material-ui/icons/Laptop';
import LaptopTwoToneIcon from '@material-ui/icons/LaptopTwoTone';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Typography } from '@material-ui/core';

const _ = require('lodash');

const fieldTypes = {
    edit: { icon: EditIcon, title: 'Edit' },
    add: { icon: AddIcon, title: 'Add' },
    save: { icon: SaveIcon, title: 'Save' },
    close: { icon: CloseIcon, title: 'Close' },
    back: { icon: ChevronLeftIcon, title: 'Back' },
    duplicate: { icon: FileCopyIcon, title: 'Duplicate' },
    cloneitems: { icon: DynamicFeedIcon, title: 'Clone Items' },
    tour: { icon: TourIcon, title: 'TourIcon' },
    download: { icon: GetAppIcon, title: 'Download' },
    refresh: { icon: RefreshIcon, title: 'Refresh' },
    lock: { icon: LockIcon, title: 'Lock' },
    unlock: { icon: UnlockIcon, title: 'Unlock' },
    reports: { icon: SaveReportIcon, title: 'Reports' },
    excel: { icon: ExportExcel, title: 'Excel' },
    clear: { icon: ClearAllIcon, title: 'Clear' },
    Filter: { icon: FilterListIcon, title: 'Filter' },
    submit: { icon: ForwardIcon, title: 'Submit' },
    reSubmit: { icon: ForwardIcon, title: 'Re-submit' },
    markread: { icon: DraftsIcon, title: 'Mark Read' },
    markunread: { icon: MarkunreadIcon, title: 'Mark Unread' },
    cancel: { icon: CancelIcon, title: 'Dismissed' },
    previtem: { icon: ArrowUpwardIcon, title: 'Previous Item' },
    nextitem: { icon: ArrowDownwardIcon, title: 'Next Item' },
    fullscreen: { icon: FullscreenIcon, title: 'Expand' },
    exitfullscreen: { icon: FullscreenExitIcon, title: 'Minimize' },
    tour: { icon: TourIcon, title: 'Tour' },
    downloadpermit: { icon: SystemUpdateAltIcon, title: 'Download Permit' },
    withdraw: { icon: AssignmentReturnIcon, title: 'Withdraw' },
    moreitems: { icon: MenuIconOpen, title: 'Sidebars' },
    lan: { icon: CallSplit, title: 'Workflow' },
    history: { icon: HistoryIcon, title: 'History' },
    check_box: { icon: CheckBox, title: 'Check' },
    doneall: { icon: DoneAll, title: 'Done' },
    preview: { icon: Preview, title: 'Preview' },
    quickview: { icon: QuickView, title: 'View' },
    delete: { icon: DeleteForeverIcon, title: 'Delete' },
    load: { icon: CameraFrontRoundedIcon, title: 'Load' },
    route: { icon: DirectionsTwoToneIcon, title: 'Route' },
    sync: { icon: SyncIcon, title: 'Sync' },
    clearDate: { icon: EventBusyIcon, title: 'Clear' },
    asofdate: { icon: DateRangeIcon, title: 'As of Date' },
    reset: { icon: Autorenew, title: 'Reset' },
    loadprevious: { icon: InputSharpIcon, title: 'Load Previous' },
    switchuser: { icon: PersonAddIcon, title: 'Switch Workflow' },
    userview: { icon: HowToRegSharpIcon, title: 'User View' },
    loadresults: { icon: AutorenewRoundedIcon, title: 'Load Results' },
    pause: { icon: PauseIcon, title: 'Pause' },
    accessaccount: { icon: LaptopTwoToneIcon, title: 'Access Account' },
    contactsupport: { icon: AccountCircleIcon, title: 'Contact Support' },
    help: { icon: Help, title: 'Help' },
    downloadapplication: { icon: GetAppIcon, title: 'Download Application' }, 
};


export default function Icons(props) {
    const { icon, type, title, color, hidevalue, menudisplay, sharedProps, name, showon, hideon, hideanother, hideconditionvalue, showOnly, historyurl, fieldValues, hideByValues,
        urlparams, fieldProps, ...otherProps } = props
    //console.log('props',fieldTypes[icon])
    const EachComp = fieldTypes[icon]?.icon;
    const Icontitle = fieldTypes[icon]?.title;
    const dispatch = useDispatch();



    const Conditions = () => {
        if (hideByValues && hideByValues.length > 0 || showOnly) {
            let hideResult = hideByValues.find(each => {
                if (each['condition']) {
                    // debugger;
                    if (each['value'] && sharedProps[each['name']] && sharedProps[each['name']].includes(each['value']))
                        return each
                    if (each['value'] && sharedProps[each['name']] && !sharedProps[each['name']].includes(each['value']))
                        return each
                }
                else if (each['value'] == sharedProps[each['name']])
                    return each
            })
            if (hideResult && showOnly) {
                let profile = JSON.parse(localStorage.getItem('profile'))
                //  let role = JSON.parse(localStorage.getItem('roles')) && JSON.parse(localStorage.getItem('roles')).find(each => each.RoleType === showOnly)
                let isRoleBased = ((profile && profile.modulePermissions && profile.modulePermissions.length > 0 &&
                    profile.modulePermissions.find(each => each.roleTypeName === 'RAME')) || (profile && profile.isAdmin === 'Y')) //role.Id.toString()
                return isRoleBased ? ((sharedProps && (sharedProps[hideon] === hidevalue || sharedProps[hideanother] === hidevalue)) ? true : false) : hideResult

            }
            else return hideResult ? true : false;
        }

        else if (((name === 'fullscreen' || name === 'exitfullscreen') && (sharedProps && (sharedProps[name] === true))) ||
            (sharedProps && sharedProps.allgriddata && (name === 'nextitem' || name === 'previtem') && (_.isEmpty(sharedProps.allgriddata))) ||
            (otherProps.onClick === "hidedisplay" || (sharedProps && (sharedProps[hideon] === hidevalue || sharedProps[hideanother] === hidevalue))))
            return true;
        else if (hideconditionvalue && getEnvVariable('AccessPortal') == 'E' && localStorage.getItem('externallock') == 'Y') {
            // debugger;
            return true;
        }
        else if (name === 'createduplicate' && getEnvVariable('AccessPortal' === 'E'))
            return true
        else return false
    }
    if (Conditions())
        return null
    else if (name === 'tour') {
        return <i className={name} onClick={() => { dispatch(showTour(true)) }}><IconButton title={title ? title : ''} color={color ? color : "inherit"}> <EachComp />  </IconButton ></i>
    }
    else if (name === 'history') {
        return <i className={name + ' zoom mx-1'} {...otherProps}><History url={historyurl} fieldValues={fieldValues} sharedProps={sharedProps} className="float-end m-2" size="small" /></i>
    }
    else if (name === 'required') {
        return <MissingItemsDrawer fieldValues={fieldValues} urlparams={urlparams} label={title} />
    }
    else if (name === 'dcrequired') {
        return <MissingItemsDrawer fieldProps={fieldProps} fieldValues={fieldValues} urlparams={urlparams} label={title} name={name} />
    }
    else if (name === 'rulessnapshot') {
        return <RulesSnapShot fieldValues={fieldValues} fieldProps={fieldProps} />
    }
    else if (menudisplay) {
        return EachComp && <EachComp className={name} style={{ color: color || "inherit" }} />
    }
    else if (name === 'quickview') {
        return <QuickView fieldValues={fieldValues} sharedProps={sharedProps} />
    }
    else if (name === 'previtem' || name === 'nextitem') {
        return null
    }
    else return <i className={name + '  m-1'} {...otherProps}><IconButton size='small' color='primary'
        title={title ? title : ''}
    >
        <EachComp fontSize="small" color='secondary' /> {getEnvVariable('IconTitle') === 'Y' && <Typography variant="caption" color='primary'>{Icontitle}</Typography>}
    </IconButton></i>
}

